module.exports = __webpack_public_path__ + "img/54_6.d2551097.png";